<template>
  <div class="info-box">
    <div v-if="!showCheck">
      <div class="info-title">
        <div class="info-block" />
        <span>基本信息</span>
      </div>
      <el-row class="info-line">
        <el-col :span="3">用户名:</el-col>
        <el-col :span="21">{{ userInfo.username }}</el-col>
      </el-row>
      <el-row class="info-line">
        <el-col :span="3">手机号:</el-col>
        <el-col :span="21">{{ userInfo.phone }}</el-col>
      </el-row>
      <el-row v-show="userInfo.email" class="info-line">
        <el-col :span="3">邮箱:</el-col>
        <el-col :span="21">{{ userInfo.email }}</el-col>
      </el-row>
      <el-row v-show="!firmRole" class="info-line">
        <el-col :span="3">会员等级:</el-col>
        <el-col :span="3">{{ level }}</el-col>
        <el-col :span="18">
          <div class="firm-link" @click="showCheck = true">
            {{ checkDescribe }}
          </div>
        </el-col>
      </el-row>
      <div v-show="firmRole" class="firm-box">
        <div class="info-title">
          <div class="info-block" />
          <span>企业信息</span>
        </div>
        <el-row class="info-line">
          <el-col :span="3">企业名称:</el-col>
          <el-col :span="21">{{ userInfo.agentName }}</el-col>
        </el-row>
        <el-row v-show="false" class="info-line">
          <el-col :span="3">企业类型:</el-col>
          <el-col :span="21">{{ userInfo.agentType }}</el-col>
        </el-row>
        <el-row class="info-line">
          <el-col :span="3">会员级别:</el-col>
          <el-col :span="21">{{ level }}</el-col>
        </el-row>
        <el-row class="info-line">
          <el-col :span="3">会员有效期:</el-col>
          <el-col :span="21">{{ userInfo.expireDateStr }}</el-col>
        </el-row>
        <div class="firm-image">
          <div>
            <div>营业执照:</div>
            <img class="image-box" :src="userInfo.businessLicense">
          </div>
          <div style="margin-left: 60px">
            <div>授权书:</div>
            <img class="image-box" :src="userInfo.authorizationLetter">
          </div>
        </div>
      </div>
    </div>
    <div v-else class="firm-check">
      <div class="firm-link" @click="showCheck = false">
        <i class="el-icon-arrow-left" />返回
      </div>
      <div v-show="checkReason" class="check-status">
        当前状态：<span
          :class="userInfo.checkStatus === 2 ? 'check-fail' : 'check-ing'"
        >{{ checkReason }}</span>
      </div>
      <enterprise-form
        :state="viewState"
        :firm="userInfo.agentName"
        :license="userInfo.businessLicense"
        :authorisation="userInfo.authorizationLetter"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { memberInfo } from '@/api/member.js'
import EnterpriseForm from '@/components/register/EnterpriseForm'

export default {
  name: 'MyInfo',
  components: { EnterpriseForm },
  data() {
    return {
      level: '',
      checkDescribe: '',
      firmRole: false,
      showCheck: false,
      checkReason: '',
      viewState: 0,
      levelList: [
        '普通用户',
        '企业用户',
        '代理商',
        '分销商',
        '银牌增值',
        '经销商',
        '金牌增值',
        '行业方案',
        '银牌分销',
        '钻石分销'
      ]
    }
  },
  watch: {
    userInfo: {
      handler: function(newV, oldV) {
        this.showInfo()
      },
      deep: true
    }
  },
  mounted() {
    this.showInfo()
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapActions(['setUserInfo', 'signOut']),
    getInfo() {
      const _this = this
      memberInfo().then((response) => {
        _this.setUserInfo(response.data)
      })
    },
    showInfo() {
      this.firmRole = this.userInfo.agentId && this.userInfo.checkStatus === 1
      // 是否为企业用户
      if (this.userInfo.agentId) {
        switch (this.userInfo.checkStatus) {
          case 0:
            this.level = '普通用户'
            this.checkDescribe = '企业用户审核中 >'
            this.checkReason = '审核中，请耐心等待'
            this.viewState = 0
            break
          case 1:
            if (this.userInfo.memberLevelId) {
              if (this.userInfo.memberLevelId === 1) {
                this.level = this.levelList[this.userInfo.memberLevelId]
              } else {
                if (this.userInfo.memberSecondLevelId) {
                  this.level = `${this.levelList[this.userInfo.memberLevelId]}-${this.levelList[this.userInfo.memberSecondLevelId]}`
                } else {
                  this.level = this.levelList[this.userInfo.memberLevelId]
                }
              }
            } else {
              this.level = this.levelList[1]
            }
            this.checkDescribe = ''
            this.checkReason = ''
            this.viewState = 0
            break
          case 2:
            this.level = '普通用户'
            this.checkDescribe = '企业用户审核失败 >'
            this.checkReason = '审核失败，' + this.userInfo.reason
            this.viewState = 2
            break
          default:
            this.level = '普通用户'
            this.checkDescribe = '升级为企业用户 >'
            this.checkReason = ''
            this.viewState = 2
            break
        }
      } else {
        if (this.userInfo.memberLevelId === 11) {
          this.level = '内部员工'
        } else {
          this.level = '普通用户'
        }
        this.checkDescribe = '升级为企业用户 >'
        this.checkReason = ''
        this.viewState = 2
      }
    },
    submitCallback() {
      this.getInfo()
    }
  }
}
</script>

<style lang="less" scoped>
.info-box {
  padding: 24px 40px;
  font-size: 14px;
  color: #3d3d3d;
}
.info-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.info-title span {
  font-weight: bold;
  margin-left: 8px;
}
.info-block {
  background: #f6713d;
  width: 4px;
  height: 14px;
  margin-bottom: 1px;
}
.info-line {
  margin: 0 0 20px 12px;
}
.firm-box {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
.firm-image {
  display: flex;
  margin: 0 0 20px 12px;
  color: black;
}
.image-box {
  margin-top: 10px;
  width: 266px;
  height: 175px;
  object-fit: contain;
}
.firm-link {
  color: #f6713d;
  cursor: pointer;
}
.firm-check {
  width: 460px;
  display: flex;
  flex-direction: column;
}
.check-status {
  background: rgba(246, 113, 61, 0.1);
  min-height: 34px;
  line-height: 34px;
  text-align: left;
  margin-top: 24px;
  padding: 0 10px;
  word-break: break-all;
}
.check-ing {
  color: #f6713d;
}
.check-fail {
  color: #F56C6C;
}
</style>
